<template>
  <div v-show="show" :class="['popup-wrapper', showInner && 'show', top && 'top']">
    <div class="popup-mask" @click.stop="close"></div>
    <div class="popup-content">
      <div class="content-header">
        <i class="icon-outline_close" @click.stop="close"></i>
        <span>{{title}}</span>
        <i></i>
      </div>
      <div class="content-slot">
        <slot :close="close"/>
      </div>
      <div v-if="footer" :class="['content-footer', $slots.footer && 'shadow']">
        <slot name="footer" :close="close"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showInner: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    top: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    document.body.appendChild(this.$el)
    if (this.show) { this.showInner = true }
  },
  watch: {
    show (newValue, oldValue) {
      if (oldValue !== newValue) {
        if (newValue) {
          this.open()
        } else {
          this.close()
        }
      }
    }
  },
  destroyed () {
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  },
  methods: {
    close () {
      this.showInner = false
      setTimeout(() => {
        this.$emit('close')
      }, 300)
    },
    open () {
      setTimeout(() => {
        this.showInner = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-wrapper {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .popup-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    background-color: #282B33;
    pointer-events: auto;
    transition: opacity  .3s ease-in-out;
    opacity: 0;
  }

  &.top {
    .popup-content {
      transform: translateY(-100%);
      top: 0;
      bottom: initial;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 24px;
      border-bottom-right-radius: 24px;
    }

  //   // &.show {
  //   //   .popup-content {
  //   //     transform: translateY(0);
  //   //   }
  //   // }
  }

  &.show {
    z-index: 89;// 层级低于toast提示的900
    .popup-mask {
      opacity: 0.5;
    }
    .popup-content {
      transform: translateY(0);
    }
  }

  .popup-content {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 100%;
    bottom: 0;
    left: 0;
    max-height: 90%;
    min-height: 50%;
    background: #FFFFFF;
    border-top-right-radius: 24px;
    border-top-left-radius: 24px;
    overflow: hidden;
    transition: transform .3s ease-in-out;
    transform: translateY(100%);

    .content-header {
      display: flex;
      min-height: 112px;
      align-items: center;
      box-sizing: border-box;
      padding: 0 48px;
      i {
        width: 40px;
        height: 40px;
        font-size: 40px;
      }
      span {
        font-family: DiDiSans-Pro-Medium;
        flex: 1;
        font-size: 36px;
        color: #000000;
        text-align: center;
        line-height: 44px;
        font-weight: 500;
      }
    }

    .content-slot {
      position: relative;
      box-sizing: border-box;
      padding: 0 40px;
      flex: 1;
      max-height: 50%;
      overflow-x: hidden;
      overflow-y: auto;
    }

    .content-footer {
      position: relative;
      height: 153px;
      justify-content: center;
      background: #FFFFFF;

      &.shadow {
        box-shadow: 0 -1px 0 0 rgba(0,0,0,0.08);
      }
    }
  }
}
</style>
